module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headeracknow01",
      "epub:type": "acknowledgments",
      "id": "acknow",
      "role": "doc-acknowledgments"
    }
  }, [_c('header', {
    attrs: {
      "id": "headeracknow01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vii",
      "id": "pvii",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsutvmamericans0007#racknow"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v(" owe a great deal of gratitude to my Society of Cinema and Media Studies friends and colleagues whose insights and impassioned conversations guided and inspired this book. Allison McCracken and Joe Wlodarz were brilliant coordinators of our lively "), _c('i', [_vm._v("Americans")]), _vm._v(" seminar, which included Laure Astourian, Ina Rae Hark, Lillian Holman, Lisa Jacobson, Barbara Klinger, Thais Miller, Daisy Pignetti, Diane Waldman, and Anna Varadi, most of whom were willing to show up in wigs and other disguises so that we could, paradoxically, “make it real.” Brenda Weber joined some of us for a follow-up panel, and later I was fortunate enough to have both Brenda and Allison McCracken as the press reviewers for this manuscript. Their thoughtful and perceptive readings and suggestions very much influenced my revisions and made this a much stronger TV Milestones offering. My thanks also to Judith Mayne, who talked me into doing this book, and to Gillian Silverman and Sarah Hagelin, who shared their own work on "), _c('i', [_vm._v("The Americans")]), _vm._v(". It was a thrill to work with all these scholars who love this series as much I do. Marie Sweetman at Wayne State University Press was with me all the way, making the book possible and a lot of fun. And as always, "), _c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "viii",
      "id": "pviii",
      "role": "doc-pagebreak"
    }
  }), _vm._v("George Bauman supported and loved me all through this project. Our time together behind the Iron Curtain is part of our unending bond, and it was especially meaningful to watch and think about this Cold War television series with him. Thanks, babe!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-272dca77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-tvmamericans-0008.vue
// module id = 75
// module chunks = 0